<template>
  <CardWithTitle
    :request-status="requestStatus"
    :item-id="itemId"
    :options-data="baseCardOptions"
    @call-option-menu="callOptionMenu"
    @reload="reload"
  >
    <v-row
      v-if="hasPost"
      class="post-container no-gutters"
    >
      <SingleSelect
        v-model="selectedLimit"
        class="select"
        :items="limitOptions"
        :searchable="false"
        :value="10"
        :clearable="false"
      />
      <v-col
        v-for="post in posts"
        :key="post._id"
        class="mb-3"
        cols="12"
      >
        <MiniPost :post="post" />
      </v-col>
    </v-row>
    <h2
      v-else
      class="no-post-title pt-16"
    >
      {{ noPostsLabel }}
    </h2>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { mapActions } from 'vuex';
import cardsModel from '@/mixins/cards-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import MiniPost from '@/components/cards/models/MiniPost';
import EventBus from '@/utils/event-bus';
import Badge from '@/components/Badge';
import SingleSelect from '@/components/filter/models/SingleSelect.vue';

export default {
  name: 'Feed',
  components: {
    SingleSelect,
    CardWithTitle,
    MiniPost,
    Badge,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    orderBy: {
      type: String,
      default: 'date_desc',
    },
  },
  data() {
    return {
      posts: [],
      requestStatus: 'loading',
      maxPostChar: 120,
      selectedLimit: 10,
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 },
      ],
    };
  },
  computed: {
    noPostsLabel() {
      return this.$t('components.models.Feed.label.noPostsLabel');
    },
    hasPost() {
      return this.posts && this.posts.length;
    },
  },
  watch: {
    selectedLimit() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    reload() {
      this.getData();
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'topPosts',
        serviceParams: {
          limit: this.selectedLimit,
          order_by: this.orderBy,
        },
      })
        .then(response => {
          this.posts = response.posts;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(() => {
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .no-post-title {
    font-size: 18px;
    text-align: center;
    color: white;
  }

  .post-container {
    height: 100%;
    width: 100%;
    overflow: auto;
  }
</style>
